import React from "react";
import {  PaymentStatus } from "states/order/order.models";

interface IPaymentStatusProps {
  paymentStatus: PaymentStatus;
}
export const PaymentStatusComponent = (props: IPaymentStatusProps) => {
  const { paymentStatus } = props;
  const renderStatus = ()=>{
    switch (paymentStatus){
      case PaymentStatus.Unpaid:
        return <React.Fragment>Chưa thanh toán</React.Fragment>;
      case PaymentStatus.Paid:
        return <React.Fragment>Đã thanh toán</React.Fragment>;
      default:
          return <React.Fragment />
    }
  }
  return (renderStatus());
};
